var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 0C5.16421 0 5.5 0.335786 5.5 0.75V1.5H8.5V0.75C8.5 0.335786 8.83579 0 9.25 0C9.66421 0 10 0.335786 10 0.75V1.5H12.25C13.0784 1.5 13.75 2.17157 13.75 3V12.75C13.75 13.5784 13.0784 14.25 12.25 14.25H1.75C0.921573 14.25 0.25 13.5784 0.25 12.75V3C0.25 2.17157 0.921573 1.5 1.75 1.5H4V0.75C4 0.335786 4.33579 0 4.75 0ZM4 3H1.75V5.25H12.25V3H10V3.75C10 4.16421 9.66421 4.5 9.25 4.5C8.83579 4.5 8.5 4.16421 8.5 3.75V3H5.5V3.75C5.5 4.16421 5.16421 4.5 4.75 4.5C4.33579 4.5 4 4.16421 4 3.75V3ZM12.25 6.75H1.75V12.75H12.25V6.75Z",
    fill: "#5B5B5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.e344b8cb06cb8b08723504511bc2843f.svg";
export { ForwardRef as ReactComponent };